import Immutable from 'immutable';

import {
  CHECK_PARENT_SUCCESS,
  CHECK_PARENT_ERROR,
  CLEAN_SEARCH_PARENT
} from '../actions/actionTypes';

export const initialState = Immutable.Map({
  checkedParent: Immutable.Map(),
  checkedError: false
});

const parentReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHECK_PARENT_SUCCESS: {
      return state.set('checkedParent', Immutable.Map(action.parent));
    }
    case CHECK_PARENT_ERROR: {
      return state.set('checkedError', true);
    }
    case CLEAN_SEARCH_PARENT: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default parentReducer;



// WEBPACK FOOTER //
// ./src/reducers/parentReducer.js